//**auto-generated don't edit this code**//
export enum ReportDisplayResultsMode {
	Score,
	Percent,
	Grade,
}